import React, { Fragment, useContext, useEffect } from 'react';

// Components
import {
	Collapse,
	IconButton,
	ListItemButton,
	ListItemText,
	Tooltip,
	useMediaQuery,
	useTheme,
	Popper,
	ClickAwayListener,
} from "@mui/material";
import List from '@mui/material/List';

// Styles
import {
	CustomDrawer,
	MiniDrawer,
	CustomIcon,
	DrawerHeader,
	Item,
	ItemIcon,
	ItemText,
	PopperContainer,
	SidebarItem,
	PopperHeader,
} from "./styles";

// API
import { NavLink, useLocation } from 'react-router-dom';
import Router from '../../router'

// Icons
import {
	ManageHistory,
	ViewComfy,
	AccountTree,
	ExpandLess,
	ExpandMore,
	ChevronLeft,
	ChevronRight,
	Map,
	Tune,
	People,
	Security,
	List as ListIcon,
	PendingActions,
	Assessment,
	Settings,
	VideoSettings,
	Description,
	Business,
	RecentActors,
	Verified,
	LocationOn,
	AdsClick,
	Traffic
} from '@mui/icons-material';

import QueryStatsIcon from '@mui/icons-material/QueryStats';
import DonutLargeIcon from '@mui/icons-material/DonutLarge';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';

import AssignmentIcon from '@mui/icons-material/Assignment';

//Services
import { WorkflowApi } from '../../services/WorkflowApi';

// Utils
import { useTranslation } from 'react-i18next'
import { CheckResponse } from '../../utils/checkResponse';

// Permissions
import { useAbility } from '@casl/react';
import { AbilityContext } from '../../Context/PermissionsContext'
import { useOffline } from '../../Context/OfflineContext';
import { ColorsContext } from '../../Context/ColorsContext';

const LinkBehavior = React.forwardRef(
	(props, ref) => {
		return <NavLink ref={ref} to={""} {...props} />
	}
)

export default function Sidebar({ open, onClose, setOpen }) {
	const ability = useAbility(AbilityContext);
	const { colors } = useContext(ColorsContext);
	const theme = useTheme();
	const isMdUp = useMediaQuery(theme.breakpoints.up("md"));
	const location = useLocation();
	const { connectionStatus, setOfflineSidebar, getOfflineSidebar } = useOffline();

	const { t } = useTranslation();
	const { check } = new CheckResponse();
	const workflowApi = new WorkflowApi();

	const [routes, setRoutes] = React.useState([])
	const [openItem, setOpenItem] = React.useState(true);
	const [offlineRoutes, setOfflineRoutes] = React.useState([]);
	const [to,] = React.useState("");

	const [anchorEl, setAnchorEl] = React.useState(null);
	const [hoveredItem, setHoveredItem] = React.useState(null);
	const [popperMinHeight, setPopperMinHeight] = React.useState(0);

	const openPopper = Boolean(anchorEl);
	const [openPopperItems, setOpenPopperItems] = React.useState({});
	const hoverTimeout = React.useRef(null);

	const fixedRoutes = [
		{
			icon: <ManageAccountsIcon style={{ fontSize: 24 }} />,
			text: 'administration',
			nested: true,
			parent: 'parent2',
			to: to,
			permissionName: "ability.can('SignUp') || ability.can('UpdateUser') || ability.can('ToggleStateUser') || ability.can('CreateCompanies') || ability.can('UpdateCompanies') || ability.can('DeleteCompanies') || ability.can('CreateWorkers') || ability.can('UpdateWorkers') || ability.can('UploadFileWorkers') || ability.can('DeleteWorkers') || ability.can('CreateContract') || ability.can('UpdateContract') || ability.can('UpdateContractor') || ability.can('UpdateTechnicalSupervisor') || ability.can('UploadAttachmentSupervisor') || ability.can('DeleteContract') || ability.can('All')",
			customPermission: true,
			children: [
				{
					icon: <People style={{ fontSize: 24 }} />,
					text: 'system.users',
					to: Router.appUsers,
					permissionName: "UserList"
				},
				{
					icon: <Business style={{ fontSize: 24 }} />,
					text: 'system.companies',
					to: Router.appCompanies,
					permissionName: "AllCompanies"
				},
				{
					icon: <RecentActors style={{ fontSize: 24 }} />,
					text: 'system.companyWorkers',
					to: Router.appCompanyWorker,
					permissionName: "GetWorkers"
				},
				{
					icon: <Description style={{ fontSize: 24 }} />,
					text: 'system.contract',
					to: Router.appContract,
					permissionName: "ContractList"
				},
				{
					icon: <AdsClick style={{ fontSize: 24 }} />,
					text: 'asset.title',
					to: Router.appAssetList,
					permissionName: "All"
				},
				/* 				{
									icon: <Verified style={{fontSize: 24}}/>,
									text: 'system.certificateValidate',
									to: Router.appValidateCertificate,
									permissionName: "GetCertificatePdfFromUniqueCode"
								}, */
				{
					icon: <Traffic style={{ fontSize: 24 }} />,
					text: 'riskLevel.title',
					to: Router.appRiskList,
					permissionName: "All"
				},
			]
		},
	];

	const identityRoutes = [
		{
			icon: <Tune style={{ fontSize: 24 }} />,
			text: 'system.title',
			nested: true,
			parent: 'parent3',
			to: to,
			permissionName: "ability.can('CreateRole') || ability.can('UpdateRole') || ability.can('CreateForm') || ability.can('UpdateForm') || ability.can('DeleteForm') || ability.can('UpdateWorkflowStatusStandard') || ability.can('CreateWorkflow') || ability.can('UpdateWorkflow') || ability.can('UpdatePasswordPolicy') || ability.can('LogList') || ability.can('CreateList') || ability.can('UpdateList') || ability.can('UpdateInactivityTime')",
			customPermission: true,
			children: [
				{
					icon: <Security style={{ fontSize: 24 }} />,
					text: 'system.rolesAndPermissions',
					to: Router.appPermissions,
					permissionName: "CreateRole"
				},
				{
					icon: <ManageHistory style={{ fontSize: 24 }} />,
					text: 'workflowManagement',
					to: Router.appWorkflowManagement,
					permissionName: "CreateWorkflow"
				},
				{
					icon: <ViewComfy style={{ fontSize: 24 }} />,
					text: 'formsv2',
					to: Router.appFormManagementV2,
					permissionName: "CreateForm"
				},
				{
					icon: <VideoSettings style={{ fontSize: 24 }} />,
					text: 'standardStatusManagement',
					to: Router.appStandardWorkflowManagement,
					permissionName: "UpdateWorkflowStatusStandard"
				},
				{
					icon: <Settings style={{ fontSize: 24 }} />,
					text: 'system.settings',
					to: Router.appSettings,
					permissionName: "ability.can('CreateWorkflow') || ability.can('UpdateWorkflow') || ability.can('UpdatePasswordPolicy') || ability.can('UpdateInactivityTime') || ability.can('UpdateAppearance')",
					customPermission: true,
				},
				{
					icon: <AssignmentIcon style={{ fontSize: 24 }} />,
					text: 'system.logs',
					to: Router.applogs,
					permissionName: "LogList"
				},
				{
					icon: <ListIcon style={{ fontSize: 24 }} />,
					text: 'lists',
					to: Router.appLists,
					permissionName: "CreateList"
				}
			]
		}
	];

	useEffect(() => {
		if (!connectionStatus) {
			const offlineOptions = getOfflineSidebar();
			const items = offlineRoutes.length > 0 ? offlineRoutes : offlineOptions;

			const newRoutes = items.map((item) => ({
				...item,
				icon: <CustomIcon baseClassName="material-icons-outlined">{item.icon}</CustomIcon>,
				text: item.name
			}));

			setRoutes(newRoutes);
		}
		else {
			loadWorkflows();
			setRoutes([]);
		}
	}, [connectionStatus])

	useEffect(() => {
		setOpenPopperItems({});
	}, [hoveredItem]);

	async function loadWorkflows(params) {
		let routesAux = [];
		let response = await workflowApi.listAllParentList(params);
		let result = check(response);

		if (result.status) {
			response.data.sort((a, b) => a.order > b.order);
			response.data.map(obj => {
				let el = {
					icon: <CustomIcon baseClassName="material-icons-outlined">{obj.icon || ''}</CustomIcon>,
					text: obj.name,
					to: obj.children === null && Router.appWorkflow.replace(':id', obj.id),
					isStatic: true,
					nested: obj.nested || null,
					parent: obj.parent || null,
					permissionName: "WorkflowList",
					children: obj.children || [],
				};
				routesAux.push(el);
			});

			// Guardar configuración de flujo LOTO para modo offline
			const lotoWorkflow = response.data.find((el) => el.id === 1075);
			if (lotoWorkflow) {
				lotoWorkflow.to = Router.appOfflineWorkflow.replace(':id', lotoWorkflow.id);
				lotoWorkflow.permissionName = "WorkflowList";
				lotoWorkflow.name = "loto.title";
				setOfflineSidebar([lotoWorkflow]);
				setOfflineRoutes([lotoWorkflow]);
			}
		};

		let parent = [
			{
				icon: <PendingActions style={{ fontSize: 24 }} />,
				text: 'myWork',
				to: Router.appMyWork,
				permissionName: "GetNotifications"
			},
			{
				icon: <AccountTree style={{ fontSize: 24 }} />,
				text: 'workflow.title',
				nested: true,
				to: to,
				parent: 'parent1',
				children: routesAux,
				permissionName: "WorkflowList"
			},
			{
				icon: <Map style={{ fontSize: 24 }} />,
				text: 'plotPlans',
				to: Router.appPlotPlans,
				permissionName: "PlotPlanList"
			},
			{
				icon: <LocationOn style={{ fontSize: 24 }} />,
				text: 'map.title',
				to: Router.appMyMap,
				permissionName: "All"
			},
			{
				icon: <Assessment style={{ fontSize: 24 }} />,
				text: 'dashboard.title',
				nested: true,
				to: to,
				parent: 'parent4',
				permissionName: "GetDashboard",
				children: [
					{
						icon: <DonutLargeIcon style={{ fontSize: 24 }} />,
						text: 'dashboard.general',
						to: Router.appDashboardReportGeneral,
						permissionName: "GetDashboard"
					},
					{
						icon: <QueryStatsIcon style={{ fontSize: 24 }} />,
						text: 'dashboard.deviations',
						to: Router.appDeviationsReport,
						permissionName: "GetDashboard"
					},
					{
						icon: <span class="material-symbols-outlined">license</span>,
						text: 'dashboard.licenses',
						to: Router.appLicensesReport,
						permissionName: "GetDashboard"
					},
					{
						icon: <span class="material-symbols-outlined">sound_detection_glass_break</span>,
						text: 'dashboard.incidents',
						to: Router.appIncidentsReport,
						permissionName: "GetDashboard"
					},
				],
			},

		]

		if (!connectionStatus) {
			setRoutes(offlineRoutes);
		}
		else {
			setRoutes(parent.concat(fixedRoutes.concat(identityRoutes)));
		}
	};

	function handleOpen(item) {
		setOpenItem({ ...openItem, [item.parent]: !openItem[item.parent] })
	}

	const handleOpenPopper = (event, item) => {
		if (hoverTimeout.current) {
			clearTimeout(hoverTimeout.current);
		}
		setAnchorEl(event.currentTarget);
		setPopperMinHeight(event.currentTarget.clientHeight);
		setHoveredItem(item);
	};

	const handleClose = () => {
		hoverTimeout.current = setTimeout(() => {
			setAnchorEl(null);
			setHoveredItem(null);
		}, 120);
	};

	const isItemActive = React.useCallback((item) => {
		if (!item) return false;
		const checkPath = (path) => path && (path === location.pathname || path === `${location.pathname?.split('/', 3)?.join('/')}`);

		const itemTo = item.targetTo || item.to || (item.id && Router.appWorkflow.replace(':id', item.id));
		if (checkPath(itemTo)) return true;

		if (item.children && Array.isArray(item.children)) {
			return item.children.some(child => {
				const childTo = child.to || (child.id && Router.appWorkflow.replace(':id', child.id));
				if (checkPath(childTo)) return true;
				if (child.children && Array.isArray(child.children)) {
					return child.children.some(gc => {
						const gcTo = gc.to || (gc.id && Router.appWorkflow.replace(':id', gc.id));
						return checkPath(gcTo);
					});
				}
				return false;
			});
		}
		return false;
	}, [location.pathname]);

	const renderNestedItems = (items, level) => {
		return items.map((item) => {
			const hasChildren = Array.isArray(item.children) && item.children.length > 0;
			const targetTo = item.to ? item.to : (!hasChildren && item.id ? Router.appWorkflow.replace(':id', item.id) : undefined);
			const key = targetTo || item.text || item.name;
			const isOpen = openPopperItems[key];

			const handleToggle = () => {
				setOpenPopperItems((prev) => ({
					...prev,
					[key]: !prev[key],
				}));
			};

			return (
				<Fragment key={key}>
					<SidebarItem
						onClick={() => {
							if (hasChildren) {
								handleToggle();
							} else {
								setAnchorEl(null);
								setHoveredItem(null);
								if (open) setOpen(false);
							}
						}}
						component={targetTo ? LinkBehavior : undefined}
						to={targetTo}
						selected={isItemActive({ ...item, targetTo })}
						sx={{
							position: "relative",
							padding: '1px 10px',
							backgroundColor: '#f5f5f5',
							'&:hover': {
								backgroundColor: '#f5f5f5',
								'& .popper-item-text': {
									backgroundColor: '#dcdbde',
									borderRadius: '8px',
								},
								'& .popper-item-text > *': {
									fontWeight: 'bold',
								}
							},
							'&.Mui-selected': {
								backgroundColor: '#f5f5f5',
								'& .popper-item-text': {
									backgroundColor: '#dcdbde',
									borderRadius: '8px',
								},
								'& .popper-item-text > *': {
									fontWeight: 'bold',
								},
								'&::before': {
									display: 'none',
								}
							},
							'&.Mui-selected:hover': {
								backgroundColor: '#f5f5f5',
							},
							'&.Mui-selected > *': {
								color: `${colors.navbarColor} !important`,
								'& .MuiTypography-root': { color: 'inherit !important' },
							},
						}}
					>
						<ListItemText
							primary={
								level >= 2
									? item.name
									: (item.isStatic ? item.text : t(`sidebar.${item.text}`))
							}
							className='popper-item-text'
							sx={{
								marginTop: '1px',
								marginBottom: '1px',
								marginLeft: level >= 2 ? '20px' : '0px',
								padding: '6px 10px',
							}}
						/>

						{hasChildren && (
							<ChevronRight
								sx={{
									fontSize: 18,
									transition: "transform 0.2s",
									transform: isOpen ? "rotate(90deg)" : "rotate(0deg)",
								}}
							/>
						)}
					</SidebarItem>

					{Array.isArray(item.children) && item.children.length > 0 && (
						<Collapse in={isOpen} timeout="auto" unmountOnExit>
							{renderNestedItems(item.children, level + 1)}
						</Collapse>
					)}
				</Fragment>
			);
		});
	};

	const renderMenuItems = (showText) => {
		const itemLabel = (item) => item.isStatic ? item.text : t(`sidebar.${item.text}`);

		const renderItem = (item) => (
			<Item component={item.to ? LinkBehavior : null} to={item.to}
				onClick={() => {
					if (item.nested) handleOpen(item);
					else if (open) setOpen(false);
				}}
				selected={isItemActive(item)}
			>
				{showText ? (
					<Tooltip title={itemLabel(item)}>
						<ItemIcon>{item.icon}</ItemIcon>
					</Tooltip>
				) : (
					<ItemIcon>{item.icon}</ItemIcon>
				)}
				{showText && <ItemText primary={itemLabel(item)} />}

				{item.nested && showText &&
					<Fragment>
						{openItem[item.parent] ? <ExpandLess /> : <ExpandMore />}
					</Fragment>
				}
				{item.nested && !showText &&
					<ChevronRight sx={{ fontSize: 14, position: 'absolute', right: 4, top: '50%', transform: 'translateY(-50%)', opacity: 0.6 }} />
				}
			</Item>
		);

		return (
			<List style={{ marginTop: 25 }}>

				<Popper
					open={openPopper}
					anchorEl={anchorEl}
					placement="right-start"
					disablePortal={false}
					modifiers={[
						{ name: "offset", options: { offset: [0, 0] } },
						{ name: "preventOverflow", options: { mainAxis: false } }, // Evita que se desplace sobre el eje Y
						{ name: "flip", enabled: false } // Evita que gire hacia arriba si no hay espacio
					]}
					sx={{
						zIndex: (theme) => theme.zIndex.drawer + 10,
					}}
				>
					<ClickAwayListener onClickAway={() => {
						setAnchorEl(null);
						setHoveredItem(null);
					}}>
						<PopperContainer
							ownerState={{ minHeight: popperMinHeight }}
							style={{ maxHeight: anchorEl ? `calc(100vh - ${anchorEl.getBoundingClientRect().top}px - 20px)` : 'auto' }}
							onMouseEnter={() => {
								if (hoverTimeout.current) {
									clearTimeout(hoverTimeout.current);
								}
							}}
							onMouseLeave={handleClose}
						>
							{hoveredItem && (() => {
								const hasChildren = Array.isArray(hoveredItem.children) && hoveredItem.children.length > 0;
								const targetTo = hoveredItem.to ? hoveredItem.to : (!hasChildren && hoveredItem.id ? Router.appWorkflow.replace(':id', hoveredItem.id) : undefined);

								return (
									<List dense sx={{ py: 0 }}>
										{/* Título parent */}
										<PopperHeader
											disabled={hasChildren}
											component={!hasChildren && targetTo ? LinkBehavior : undefined}
											to={!hasChildren && targetTo ? targetTo : undefined}
											onClick={() => {
												if (!hasChildren) {
													setAnchorEl(null);
													setHoveredItem(null);
													if (open) setOpen(false);
												}
											}}
											sx={{ py: 0.5 }}
										>
											<ListItemText
												primary={
													hoveredItem.isStatic
														? hoveredItem.text
														: t(`sidebar.${hoveredItem.text}`)
												}
												primaryTypographyProps={{
													fontWeight: 600,
													color: colors.navbarColor,
													opacity: 1
												}}
											/>
										</PopperHeader>

										{/* Children recursivos */}
										{hoveredItem.children && renderNestedItems(hoveredItem.children, hoveredItem.children.length > 0 ? 1 : 0)}
									</List>
								);
							})()}
						</PopperContainer>
					</ClickAwayListener>
				</Popper>

				{routes.map((item, index) => (
					<>
						{(item.customPermission ? eval(item.permissionName) : ability.can(item.permissionName)) &&
							<Fragment key={"item-" + index}>
								{!showText ? (
									<SidebarItem
										component={!item.nested && item.to ? LinkBehavior : undefined}
										to={!item.nested && item.to ? item.to : undefined}
										selected={isItemActive(item)}
										onClick={(e) => {
											handleOpenPopper(e, item);
											if (item.nested) handleOpen(item);
											else if (open) setOpen(false);
										}}
										onMouseEnter={(e) => handleOpenPopper(e, item)}
										onMouseLeave={handleClose}
										sx={{
											position: "relative",
											...(openPopper && hoveredItem?.text === item.text ? {
												background: `${colors.sidebarSelectColor} !important`,
												'& > *': { color: `${colors.navbarColor} !important` },
												'&.Mui-selected': {
													background: `${colors.sidebarSelectColor} !important`,
													'& > *': { color: `${colors.navbarColor} !important` }
												}
											} : {})
										}}
									>
										<ItemIcon>{item.icon}</ItemIcon>

										{Array.isArray(item.children) && item.children.length > 0 && (
											<ChevronRight
												sx={{
													fontSize: 14,
													position: "absolute",
													right: 4,
													top: "50%",
													transform: "translateY(-50%)",
													opacity: 0.6,
												}}
											/>
										)}
									</SidebarItem>
								) : (
									renderItem(item)
								)}
								{item.nested && showText &&
									<Collapse in={openItem[item.parent]} timeout="auto" unmountOnExit>
										<List component="div" disablePadding>
											{item.children?.map((child) => (
												<>
													{(child.customPermission ? eval(child.permissionName) : ability.can(child.permissionName)) &&
														<Item key={child.to + "-child"}
															component={child.to ? LinkBehavior : null} to={child.to}
															onClick={() => {
																if (child.nested) handleOpen(child);
																else if (open) setOpen(false);
															}}
															selected={isItemActive(child)}
															sx={{ pl: 2 }}
														>
															<Tooltip title={child.isStatic ? child.text : t(`sidebar.${child.text}`)}>
																<ItemIcon>{child.icon}</ItemIcon>
															</Tooltip>
															{showText && <ItemText primary={child.isStatic ? child.text : t(`sidebar.${child.text}`)} />}

															{child.nested && showText &&
																<Fragment>
																	{openItem[child.parent] ? <ExpandLess /> : <ExpandMore />}
																</Fragment>
															}
														</Item>
													}
													{child.nested && showText &&
														<Collapse in={openItem[child.parent]} timeout='auto' unmountOnExit>
															<List component='div' disablePadding>
																{child.children?.map((el, index) => (
																	<Item key={`${index}-child`}
																		component={LinkBehavior} to={Router.appWorkflow.replace(':id', el.id)}
																		selected={isItemActive(el)}
																		onClick={() => { if (open) setOpen(false); }}
																		sx={{ pl: 4, gap: '0.5rem' }}
																	>
																		<Tooltip title={el.name}>
																			<CustomIcon baseClassName="material-icons-outlined">{el.icon}</CustomIcon>
																		</Tooltip>
																		{showText && <ItemText primary={el.name} />}

																	</Item>
																))}
															</List>

														</Collapse>
													}
												</>

											))}
										</List>
									</Collapse>
								}
							</Fragment>
						}
					</>
				))}
			</List>
		);
	}

	return (
		<>
			{/* Mini sidebar - siempre visible en desktop, solo iconos */}
			{isMdUp && (
				<MiniDrawer
					variant="permanent"
					anchor="left"
				>
					<DrawerHeader />
					{renderMenuItems(false)}
				</MiniDrawer>
			)}

			{/* Sidebar completo - overlay temporal */}
			<CustomDrawer
				open={open}
				variant="temporary"
				anchor="left"
				onClose={() => setOpen(false)}
			>
				<DrawerHeader>
					<IconButton onClick={onClose}>
						<ChevronLeft fontSize="large" style={{ color: '#ccc' }} />
					</IconButton>
				</DrawerHeader>
				{renderMenuItems(true)}
			</CustomDrawer>
		</>
	);
}
